import { useState } from "react";
import { Modal } from "react-bootstrap";
import { Input } from "../../../../Utility/FormElements";
import { toast } from "react-toastify";

function BatchPrintModal({ show, onClose, onConfirmation }) {
  const [typedAgreement, setTypedAgreement] = useState("");

  const handleChangeTypedAgreement = (event) => {
    setTypedAgreement(event.target.value);
  };

  const withOnClose = () => {
    setTypedAgreement("");
    onClose();
  };

  const validatedHandleBatchPrint = () => {
    // make it so that it is not case sensitive
    if (typedAgreement.toLowerCase().trim() === "yes") {
      onConfirmation();
      setTypedAgreement("");
    } else {
      toast.error(
        "Please type YES into the text field if you would like to batch print.",
      );
    }
  };

  return (
    <Modal show={show} onHide={withOnClose} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>Batch Print</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          Batch print all labels for the current date range. <br />
          Diligent is not responsible for lost packages due to mislabeling by
          client. Print at your own risk. <br />
          Are you sure you wish to proceed? <br />
          Type YES to initiate batch print. This may take a few moments.
        </p>
        {/* <DiliTextCP
                autocomplete="off"
                name="typedAgreement"
                value={typedAgreement}
                validationTest={(input) => {
                  return input === "YES";
                }}
                placeholder="Type YES here if you would like to proceed."
                onChange={handleChangeTypedAgreement}
              /> */}

        <Input
          type="text"
          name="typedAgreement"
          value={typedAgreement}
          onChange={handleChangeTypedAgreement}
          placeholder="Type YES here if you would like to proceed."
        />
      </Modal.Body>

      <Modal.Footer>
        <button
          className="btn btn-primary"
          type="button"
          onClick={validatedHandleBatchPrint}
        >
          Batch Print
        </button>
        <button
          className="btn btn-secondary"
          type="button"
          onClick={withOnClose}
        >
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default BatchPrintModal;
